<template>
    <g-card
      :temCabecalho="false"
      :expansivel="false"
    >

    <div class="header-observacoes-pedido-andamento">
      <div class="header-titulo-voltar">
          <g-button
          class="buscar-button-header"
          largura="35px"
          icone="icone_voltar.svg"
          negritoTexto
          tamanhoIcone="10px"
          cor="#FFFFFF"
          altura="30px"
          :sombreado="false"
          @click="voltar()"
          />

        <div class="card-titulo-observacoes"> Observações do Pedido </div>
      </div>

      <!-- <div class="header-icons" v-tooltip="'Abre uma janela para a impressão dos detalhes do cliente!'">
          <g-button
          class="botoes"
          altura="35px"
          largura="35px"
          tamanhoIcone="15px"
          icone="icone_print.svg"
          @click="imprimir()"
          >
          </g-button>
      </div> -->
    </div>

    <div class="conteudo-card-parcelas-observacoes-andamento">
      <div class="grupo">Dados Gerais</div>

       <div class="dados-observacoes-titulo"></div>
                <div class="grupo-dados-observacoes topico">

                    <div class="observacoes-cliente">
                        <div class="titulo"> Pedido / Parcela </div>
                        <div class="conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoPedido}} / {{this.observacoesPedidoAndamento.NumeroParcela}} </div>
                    </div>

                    <div class="observacoes-unidade">
                        <div class="titulo"> Orçamento </div>
                        <div class="conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoOrcamento}} </div>
                    </div>

                    <div class="produto-observacoes-produto">
                        <div class="titulo"> Produto </div>
                        <div class="conteudo"> {{ this.detalhesDoPedidoFluxo.CodigoProduto }} - {{ this.detalhesDoPedidoFluxo.NomeProduto }} </div>
                    </div>

                    <div class="observacoes-cv">
                        <div class="titulo"> CV </div>
                        <div class="conteudo"> {{this.detalhesDoPedidoFluxo.CurvaClienteTexto}} </div>
                    </div>

                    <div class="observacoes-representante">
                        <div class="titulo"> Representante </div>
                        <div class="conteudo"> {{this.detalhesDoPedidoFluxo.NomeRepresentante}} </div>
                    </div>

                    <div class="observacoes-unidade">
                        <div class="titulo"> Unidade </div>
                        <div class="conteudo"> {{this.detalhesDoPedidoFluxo.NomeEmpresa}} </div>
                    </div>

                    <div class="observacoes-cliente/CNPJ">
                        <div class="titulo"> Cliente / CNPJ </div>
                        <div class="conteudo"> {{this.detalhesDoPedidoFluxo.CodigoExternoCliente}} - {{this.detalhesDoPedidoFluxo.NomeFantasia}} / {{this.detalhesDoPedidoFluxo.CnpjFormatado }} </div>
                    </div>

                    <div class="observacoes-tipo">
                        <div class="titulo"> Tipo </div>
                        <div class="conteudo"> {{this.detalhesDoPedidoFluxo.TipoPedidoTexto}} </div>
                    </div>
                </div>
                <hr>

        <div class="grupo-dados-observacoes topico">
        <div class="data-entrega-grid">
          <div class="titulo">Data Entrega</div>
          <div class="conteudo">{{observacoesPedidoAndamento.DataEntregaFormatada || 'Sem dados'}}</div>
        </div>
        <div class="data-carreg-grid">
          <div class="titulo">Data Carreg.</div>
          <div class="conteudo">{{observacoesPedidoAndamento.DataCarregamentoFormatada || 'Sem dados'}}</div>
        </div>
        <div class="data-base-grid">
          <div class="titulo">Data Base</div>
          <div class="conteudo">{{observacoesPedidoAndamento.DataBasePedidoParcelaFormatada || 'Sem dados'}}</div>
        </div>
        <div class="oc-grid">
          <div class="titulo">O.C.</div>
          <div class="conteudo">{{observacoesPedidoAndamento.NumeroOrdemDeCompra || 'Sem dados'}}</div>
        </div>
        <div class="liberado-grid">
          <div class="titulo">Liberado para produzir</div>
          <div class="conteudo">{{observacoesPedidoAndamento.LiberadoParaProduzir === true ? 'Sim' : 'Não' || 'Sem dados'}}</div>
        </div>
        <div class="qtde-grid">
          <div class="titulo">Qtde</div>
          <div class="conteudo">{{observacoesPedidoAndamento.NumeroQuantidadeTotalFormatado || 'Sem dados'}}</div>
        </div>
        <div class="qtde-produzida-grid">
          <div class="titulo">Qtde Produzida</div>
          <div class="conteudo">{{observacoesPedidoAndamento.QuantidadeProduzida || 'Sem dados'}}</div>
        </div>
        <div class="qtde-expedida-grid">
          <div class="titulo">Qtde Expedida</div>
          <div class="conteudo">{{observacoesPedidoAndamento.QuantidadeExpandida || 'Sem dados'}}</div>
        </div>
        <div class="componente-grid">
          <div class="titulo"> Componente </div>
          <div class="conteudo" v-for="(componente, index) in CompFaseArray" :key="index"> {{componente.componenteTipoEnumTexto}} </div>
        </div>
        <div class="fase-producao-grid">
          <div class="titulo"> Fase de Produção </div>
        <div class="conteudo" v-for="(componente, index) in CompFaseArray" :key="index"> {{componente.descricaoFaseProduto|| 'Não Possui'}} </div>
        </div>
      </div>
      <hr>

    <div class="grupo">Observações</div>
    <div v-if="this.observacoesInfoArray == 0" class="flex-container">
    <div class="titulo"> Essa Parcela não possui Observações </div>
    </div>
    
    <div class="grupo-obs" v-for="data in observacoesInfoArray" :key="data.pedidoParcelaId">
    <div class="conteudo-infos">
        
      <div class="conteudo-obs">
      <div class="fase-producao-grid">
        <div class="titulo">Observação </div>
        <div class="conteudo-observacao">{{data.descricaoObservacao || 'Sem dados'}}</div>
      </div>
      <div class="fase-producao-grid origem-container">
        <div class="titulo">Origem</div>
        <div class="conteudo">{{data.descricaoOrigem || 'Sem dados'}}</div>
      </div>
      <div class="fase-producao-grid">
        <div class="titulo">Destino</div>
        <div class="conteudo">{{data.descricaoDestino || 'Sem dados'}}</div>
      </div>
      <div class="fase-producao-grid">
        <div class="titulo">Tipo</div>
        <div class="conteudo">{{data.tipoPedidoTexto || 'Sem dados'}}</div>
      </div>
    </div>
    </div>
  </div>
</div>
    </g-card>
</template>
<script>
import ObservacoesPedidoEmAndamentoPDF from './ObservacoesPedidoEmAndamentoPDF.js'
export default ObservacoesPedidoEmAndamentoPDF
</script>
<style scoped>
 .header-titulo-voltar {
    width: 100%;
    display: flex;
    align-items: flex-end;
  }

  .titulo {
    color: #3e3e3e;
    text-align: left;
    font-family: "MontSerrat";
    font-weight: 500;
    margin-top: 15px;
  }

  .conteudo-observacao{
    font-family: monospace;
    max-width: 50ch;
    white-space: break-spaces;
    text-align: initial;
  }

  .conteudo {
    color: #8a8a8a;
    text-align: left;
    font-family: "MontSerrat";
    margin-bottom: 10px;
  }

  .card-titulo-observacoes {
    color: #4f2c19;
    font-weight: bold;
    font-size: 1.1rem;
  }

  .grupo {
    color: #4f2c19;
    text-align: left;
    font-family: "MontSerrat";
    font-weight: bold;
    margin-top: 30px;
    display: flex;
  }

  .grupo-dados-observacoes {
    display: grid;
    grid-template-columns: repeat(2, auto);
    grid-template-rows: repeat(4, auto);
    }

  @media (min-width:310px) {
    .header-observacoes-pedido-andamento {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      border-bottom: 1px solid #f0f0f0;
      margin-top: 3rem;

    }
  }

  @media (min-width:368px) {
    .header-observacoes-pedido-andamento {
        grid-template-columns: 25% repeat(2, auto);
    }
  }


  @media (min-width:600px) {
    .header-observacoes-pedido-andamento {
        padding: 20px 0 10px;
    }
  }


  @media (min-width:801px) {
    .conteudo-card-parcelas-observacoes-andamento {
      padding: 0 30px;
    }
  }


  @media (min-width:1025px) {
    .grupo {
      font-size: 19px;
    }

    .grupo-dados-observacoes {
    grid-template-columns: repeat(4, 1fr);
    }

  .conteudo-card-parcelas-observacoes-andamento {
      padding: 0 50px;
    }
  }


  @media (min-width:1281px) {}
  </style>